let u = 'undefined',
  win = typeof window !== u ? window : {},
  p = typeof performance !== u ? performance : Date,
  now = () => p.now(),
  af = 'AnimationFrame',
  Caf = 'cancel' + af,
  Raf = 'request' + af,
  raf = win[Raf] && win[Raf].bind(win),
  caf = win[Caf] && win[Caf].bind(win)

function _ref(h) {
  return clearTimeout(h)
}

if (!raf || !caf) {
  let lastTime = 0

  raf = (callback) => {
    let curr = now(),
      next = Math.max(lastTime + 1000 / 60, curr)
    return setTimeout(() => {
      callback((lastTime = next))
    }, next - curr)
  }

  caf = _ref
}

export {raf, caf, now}
